// A click the browser should handle natively (new tab / new window) rather than the app.
export const isModifiedClick = (e) => e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0;
